import React from 'react'
import FallbackFileUpload from './fallback'

let FilePickerComponent = null

try {
  // Using require instead of import for better build-time handling
  const filePickerModule = require('@protonapp/runner-filepicker') // eslint-disable-line global-require
  FilePickerComponent = filePickerModule.default || filePickerModule
} catch (err) {
  console.warn('FilePicker package not found:', err)
  // Fallback component when package is missing
  FilePickerComponent = FallbackFileUpload
}

export default function FileUpload(props) {
  return <FilePickerComponent {...props} />
}
